import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import GalleryImage from "./GalleryImage";
import Button from "../Button/Button";
import "./Gallery2.css";

const CAROUSEL_RESPONSIVE_CONFIG = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 1400 }, items: 4 },
  desktop: { breakpoint: { max: 1400, min: 1100 }, items: 4 },
  tablet: { breakpoint: { max: 1100, min: 768 }, items: 3 },
  smallTablet: { breakpoint: { max: 768, min: 500 }, items: 2 },
  mobile: { breakpoint: { max: 500, min: 0 }, items: 1 },
};

const Gallery = () => {
  const [galleryImages, setGalleryImages] = useState([]);

  useEffect(() => {
    const loadGalleryData = async () => {
      try {
        const data = await import("../../config/data.json");
        setGalleryImages(data.gallery_images || []);
      } catch (error) {
        console.error("Failed to load gallery images:", error);
      }
    };

    loadGalleryData();
  }, []);

  useEffect(() => {
    if (galleryImages.length > 0) {
      preloadCriticalImages(galleryImages);
    }
  }, [galleryImages]);

  const preloadCriticalImages = (images) => {
    if (typeof window !== "undefined") {
      images.slice(0, 3).forEach((img) => {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = img.src;
        document.head.appendChild(link);
      });
    }
  };

  return (
    <div className="gallery-container">
      <Carousel
        responsive={CAROUSEL_RESPONSIVE_CONFIG}
        autoPlay
        autoPlaySpeed={2000}
        infinite
        arrows={false}
        showDots={false}
        keyBoardControl
        swipeable
        draggable
        containerClass="carousel-container-ng"
        itemClass="carousel-item-spacing"
        renderButtonGroupOutside={true}
        minimumTouchDrag={80}
        slidesToSlide={1}
      >
        {galleryImages.map((img, index) => (
          <GalleryImage
            key={`${img.alt}-${index}`}
            src={img.src}
            hash={img.hash}
            alt={img.alt}
            priority={index < 4}
          />
        ))}
      </Carousel>
      <div className="gallery-action">
        <Link to="/masonary">
          <Button
            text="Discover Gallery"
            size="discord"
            color="black"
            type="button"
            className="fs-6"
          />
        </Link>
      </div>
    </div>
  );
};

export default Gallery;
